import React from 'react'
import { Card, CardBody } from "reactstrap";
import image from "../../../../assets/images/if_dash/Vector.png"

function RecentExitCard({color,recbadge,backgroundcolor,employName,post,time, confidence}) {
  return (
    <>
      <Card>
        <CardBody style={{ border: "1px solid #E4E4E7", borderRadius: "8px" }}>
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <div className="d-flex align-items-center gap-2">
              <img
                style={{
                  height: "40px",
                  width: "40px",
                 
                  borderRadius: "50%",
                }}
                src={image}
                alt=""
              />
              <div className="d-flex ">
                <div>
                  <h2 style={{ fontSize: "16px", fontWeight: "600" }}>
                    {employName}
                  </h2>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#4B5563",
                      margin: "0px",
                    }}
                  >
                    {post}
                  </p>
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "400",
                      color: "#6B7280",
                      margin: "0px",
                    }}
                  >
                    Detected at {time}
                  </p>
                </div>

                <div style={{ alignSelf: "flex-start" }}>
                  <button
                    style={{
                      fontSize: "12px",
                      color: color,
                      backgroundColor: backgroundcolor,
                      padding: "3px 11px",
                      borderRadius: "30px",
                      border: "none",
                      marginLeft:"5px",
                      fontWeight:"600"
                    }}
                  >
                    {recbadge}
                  </button>

                  <button
                    style={{
                      fontSize: "12px",
                      color: "#18181B",
                      backgroundColor: "#F4F4F5",
                      padding: "3px 11px",
                      borderRadius: "30px",
                      border: "none",
                      marginLeft:"5px"

                    }}
                  >
                    Exit
                  </button>
                </div>
              </div>

             
            </div>

            {/* //............................ */}

             <div>
                <h2
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#16A34A",
                  }}
                >
                {confidence}
                </h2>
                <p
                  style={{
                    fontSize: "12px",
                    fontWeight: "400",
                    color: "#6B7280",
                    lineHeight: "13px",
                    fontWeight:"600"
                  }}
                >
                  Exit Camera
                </p>
              </div>
          </div>
        </CardBody>
      </Card>
    </>
  )
}

export default RecentExitCard